/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

// "Name on Card" is not allowed to be empty
// "Card Number" length must be at least 16 characters long
// "Expiration Date" with value "11/1" fails to match the MM/YY pattern

const ErrorLanguages = (error) => {
    const isEmpty = /^"([^"]+)".*empty/;
    const maxLength = /^"[^"]+".*(ust be at least \d+ characters long)/;
    const matchPasswordPattern = /^"[^"]+".+(password condition a)(t least 6 characters long with 1 number and 1 letter pattern)/;
    const matchPasswordPattern2 = /^"[^"]+".+(Password must be at least 8 characters long with a mix of uppercase, lowercase, numbers and symbols.)/;
    const matchCharsPattern = /^"[^"]+".*(ails to match the .+ pattern)/;
    const invalidEmail = /^"[^"]+".*must be a (valid email)/;
    const confirmEmail = /^"[^"]+" must be one of \[ref:[^\]]+\]/;
    let errorMessage = error;
    if (isEmpty.test(error)) {
        errorMessage = ''.concat('Enter ', error.replace(isEmpty, '$1'));
    } else if (error?.includes('24 characters long')) {
        errorMessage = ''.concat('25 characters max');
    } else if (maxLength.test(error) && !matchPasswordPattern2.test(error)) {
        errorMessage = ''.concat('M', error.replace(maxLength, '$1'));
    } else if (matchPasswordPattern.test(error)) {
        errorMessage = ''.concat(
            'A',
            error.replace(matchPasswordPattern, '$2'),
        );
    }  else if (matchPasswordPattern2.test(error)) {
        errorMessage = ''.concat(
            '',
            error.replace(matchPasswordPattern2, '$1'),
        );
    } else if (matchCharsPattern.test(error)) {
        errorMessage = ''.concat('F', error.replace(matchCharsPattern, '$1'));
    } else if (invalidEmail.test(error)) {
        errorMessage = ''.concat('In', error.replace(invalidEmail, '$1'));
    } else if (confirmEmail.test(error)) {
        errorMessage = ''.concat('Please enter the same email.', error.replace(confirmEmail, ''));
    }
    return errorMessage;
};

export default ErrorLanguages;
